import React, { FC, Fragment } from 'react';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';
import { CollapsibleRow } from '../CollapsibleRow';
import { CustomTable } from '../../../../models/CustomTable';

export const BasicTable: FC<CustomTable> = ({ className, caption, tableBodyCells, tableHead }) => {
  return (
    <Table className={`custom-table ${className || ''}`}>
      {caption && <caption>{caption}</caption>}
      <TableHead>
        <TableRow>
          {tableHead.map((el) => {
            return <TableCell key={el}>{el}</TableCell>;
          })}
        </TableRow>
      </TableHead>
      <TableBody>
        {tableBodyCells?.length &&
          tableBodyCells.map((el) => {
            if (el.history) {
              return (
                <Fragment key={`${el.id}`}>
                  <CollapsibleRow {...el} />
                </Fragment>
              );
            }
            return (
              <TableRow key={`${el.id}`}>
                {el.label && <TableCell>{el.label}</TableCell>}
                {el.bodyCells.map((cell, index) => {
                  return (
                    <TableCell key={`${cell}${index + 1}`} className={el.isDisabled ? 'disabled' : undefined}>
                      {cell}
                    </TableCell>
                  );
                })}
              </TableRow>
            );
          })}
      </TableBody>
    </Table>
  );
};
